import React from 'react';
import { useAuth } from 'react-oidc-context';

/**
 * A component that ensures authentication before rendering its children.
 * It checks the authentication status and displays the children elements only
 * when the user is authenticated. If authentication is loading or the user
 * is not authenticated, nothing is rendered.
 *
 * @return Returns the children components when the user is authenticated, or null otherwise.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading || !isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
